import { Component, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { SportsService } from 'src/app/services/sports.service';
import { Subscription } from 'rxjs';
import { ISport } from 'src/app/models/sportHierarchy/sport';
import { IRegion } from 'src/app/models/sportHierarchy/region';
import { UtilityService } from 'src/app/services/util/utility.service';
import { PageType, ComponentName, TimeFilter, ErrorLevel } from 'src/app/models/enums';
import { ActivatedRoute } from '@angular/router';
import { ICompetition } from 'src/app/models/sportHierarchy/competition.iterface';
import { QueryParamsService } from 'src/app/services/http/queryParams.service';
import { ModelMapperService } from 'src/app/services/util/model.mapper.service';
import { StorageService } from 'src/app/services/util/storage.service';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { CacheService } from 'src/app/services/cache.service';
import { CacheChangesService } from 'src/app/services/cacheChanges.service';
import { ICustomNotification } from 'src/app/models/notification/customNotification.interface';
import { NotificationService } from 'src/app/services/notification.service';
import { LoaderService } from 'src/app/services/loader.service';
// import { TypeScriptEmitter } from '@angular/compiler';
import { IEventSrc } from 'src/app/models/event/eventSrc.interface';
import { ISrcSelectionIds } from 'src/app/models/util/srcSelectionIds.interface';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
// declare var $: any;

@Component({
  selector: 'app-sports-competition-tree',
  templateUrl: './sportsCompetitionTree.component.html',
  styleUrls: ['./sportsCompetitionTree.component.less']
})
export class SportsCompetitionTreeComponent implements OnInit, OnChanges, OnDestroy {
  private loadedEventsTimeFilter: TimeFilter;
  sports: ISport[] = [];
  isMobileView: boolean;
  selectedSport: ISport = null;
  pageType: PageType = PageType.Prematch;
  isLive = false;
  favoriteCompetitions: ICompetition[] = [];
  favoriteLeaguesIsExpanded = false;
  myLeaguesTitle: string;
  public favoriteCompetitionsHaveOnlineEvents = false;
  public pageTypeEnum = PageType;
  public showMostPopularSports = false;

  eventHTML: any;
  private subscription: Subscription = new Subscription();

  dynamicTranslations = DynamicTranslations;
  public viewConfigurations = ViewConfigurations;



  constructor(
    public sportsService: SportsService,
    protected utilityService: UtilityService,
    protected route: ActivatedRoute,
    protected queryParamService: QueryParamsService,
    protected cacheChanges: CacheChangesService,
    protected modelMapper: ModelMapperService,
    protected cache: CacheService,
    protected notificationService: NotificationService,
    protected storage: StorageService,
    public loaderService: LoaderService) {
    this.subscription.add(sportsService.timeFilterChanged$.subscribe((x) => {
      this.showMostPopularSports = false;
      this.getSportsTree();
    }));
    this.subscription.add(this.queryParamService.pageTypeChanged$.subscribe((pt) => this.pageType = pt));

    this.subscription.add(this.cache.sportTreeElementsWithAddedRemovedEventsChanged$.subscribe(s => {
      this.getSportsTree(s);
    }));
    this.subscription.add(this.sportsService.favoriteCompetitionSRCChanged$.subscribe(s => {
      this.addRemoveCompetitionToFavoritesFromService(s);
    }));
    this.subscription.add(this.cache.sportTreeChanged$.subscribe(() => {
      this.getSportsTree(null, this.isMobileView ? true : false);
    }));
    this.isMobileView = utilityService.mobileView;

    this.subscription.add(this.sportsService.openCompetitionFromBanner$.subscribe(() => {
      if (this.loadedEventsTimeFilter === TimeFilter.All) {
        this.selectFromBanner();
      }
    }));

  }

  ngOnInit(): void {

    // this.pageType = this.queryParamService.pageType;
    if (this.pageType === PageType.Live) {
      this.isLive = true;
    } else {
      this.isLive = false;
    }
    this.getSportsTree();


    this.isMobileView = this.utilityService.mobileView;
    this.myLeaguesTitle = DynamicTranslations.favoriteButtonName;
  }

  getSportsTree(changedElements?: ISrcSelectionIds[], onlyUpdate?: boolean) {
    if (changedElements && changedElements.length === 0 && this.isMobileView && ViewConfigurations.useMobileViewWithTopMenu) {
      return;
    }
    this.sportsService.favoriteCompetitions = this.storage.favoriteCompetitions.map(c => {
      c.eventsCount = 0;
      return c;
    });
    if (this.pageType === PageType.Results) {
      return;
    }
    this.loaderService.showHideLoader(true);

    this.sportsService.getPMSportsTreeForFilterCache().subscribe(sports => {
      this.loadedEventsTimeFilter = this.sportsService.timeFilterValueGet;
      const regularSpIndex = sports.findIndex(s => s.id > 0);

      const mostPopularButtonAsSport: ISport = {
        eventsCount: null,
        id: -99,
        isSelected: false,
        name: DynamicTranslations.otherTranslations_EventsHeader_MostPlayed,
        regions: [],
        // competitions,
        // selections: [],
        showRegions: this.pageType === PageType.MostPopular ? true : false,
        orderNo: 0,
        specialOfferType: null
      };

      if (regularSpIndex > -1) {
        mostPopularButtonAsSport.orderNo = regularSpIndex - 1;
        sports.splice(regularSpIndex, 0, mostPopularButtonAsSport);
      } else {
        mostPopularButtonAsSport.orderNo = regularSpIndex - 0;
        sports.push(mostPopularButtonAsSport);
      }

      this.cacheChanges.removeSportsSubscribtion(false);
      this.cacheChanges.addSportsSubscribtion(sports.map(s => s.id), false);

      this.favoriteCompetitionsHaveOnlineEvents = false;
      for (let index = 0; index < this.sportsService.favoriteCompetitions.length; index++) {
        const favCmp = this.sportsService.favoriteCompetitions[index];
        favCmp.isShown = false;
        const sport = sports.find(s => s.id === favCmp.sportId);
        if (sport) {
          const region = sport.regions.find(r => r.id === favCmp.regionId);
          const competition = region ? region.competitions.find(c => c.id === favCmp.id) : null;
          if (competition) {
            competition.isInFavorites = true;
            this.sportsService.favoriteCompetitions[index] = competition;
            if (competition.eventsCount > 0) {
              this.favoriteCompetitionsHaveOnlineEvents = true;
            }
          }
        }
      }
      this.favoriteCompetitions = this.sportsService.favoriteCompetitions;

      const srcSelectionIds = this.sportsService.getSportRegionCompetitionSelectionIds(this.isLive);
      if (onlyUpdate && this.selectedSport?.id < 0) {

      } else {
        this.sports = sports;
      }
      // const outrightsId = this.utilityService.getSpecialOfferSportId(SpecialOfferType.Outrights);
      // // dont show outrights for cro
      // if (this.viewConfigurations.showOutrights === false && sports.find(sport => sport.id === outrightsId)) {
      //   const index = this.sports.findIndex(sport => sport.id === outrightsId);
      //   this.sports.splice(index, 1);
      // }

      if (srcSelectionIds.sId && this.sportsService.loadCompetitionOrEventFromQuery) {
        const sp = sports.find((s) => s.id === srcSelectionIds.sId);
        if (sp) {
          this.selectedSport = sp;
          sp.isSelected = true;
          sp.showRegions = true;
          if (srcSelectionIds.rId) {
            const reg = sp.regions.find((r) => r.id === srcSelectionIds.rId);
            if (reg) {
              reg.isSelected = true;
              reg.showCompetitions = true;
              const cmp = reg.competitions.find((c) => c.id === srcSelectionIds.cId);
              if (srcSelectionIds.cId) {
                if (cmp) {
                  this.selectCompetition(cmp, reg, sp);
                }
              }
            }
          }
        }
      }

      if (this.isMobileView && !this.sportsService.loadCompetitionFromBanner) {
        let slectedSportTemp: ISport;
        if (this.selectedSport) {
          slectedSportTemp = this.sports.find(s => s.id === this.selectedSport.id);
          if (slectedSportTemp) {
            if (slectedSportTemp.eventsCount < 1) {
              if (slectedSportTemp.id !== -99) {
                slectedSportTemp.showRegions = false;
              }
              // else {
              //   this.showMostPopularSports = false;
              // }
            }
          }
        }
        this.loaderService.showHideLoader(false);
        return;
      }
      // tslint:disable-next-line:prefer-for-of

      if (this.pageType === PageType.Prematch) {
        if (!srcSelectionIds.sId && !srcSelectionIds.cId) {
          if (!this.isMobileView) {
            this.sportsService.selectSportNotify(null, this.isLive, ComponentName.SportTreeComponent);
          } else {
            this.selectFirstSport(sports);
          }
        }
        else {
          let sport = sports.find(s => s.id === srcSelectionIds.sId);
          if (sport) {
            let competition = null;
            let regionn = null;
            if (sport && sport.eventsCount < 1) {
              if (!sport.specialOfferType) {
                this.sendNoEventsNotification(DynamicTranslations.notification_noEventsInSport);
                sport = sports.find(s => s.eventsCount > 0);
              }
            }
            for (const region of sport.regions) {
              competition = region.competitions?.find(c => c.id === srcSelectionIds.cId);
              if (competition) {
                regionn = region;
                break;
              }
            }
            if (competition) {
              this.selectCompetition(competition, regionn, sport);
            } else {
              this.selectSport(sport);
            }
          } else {
            this.selectFirstSport(this.sports);
          }
        }
        this.loaderService.showHideLoader(false);

      }

      if (this.sportsService.loadCompetitionFromBanner) {
        this.sportsService.loadCompetitionFromBanner = false;
      }
    });
  }

  updateTree(sports: ISport[]){
    for (const sport of this.sports) {
      const newSport = sports.find(s => s.id === sport.id);
      if (newSport) {
        sport.eventsCount = newSport.eventsCount;
        for (const region of sport.regions) {
          const newRegion = newSport.regions.find(r => r.id === region.id);
          if (newRegion) {
            region.eventsCount = newRegion.eventsCount;
          } else {
            region.eventsCount = 0;
          }
        }
      } else {
        sport.eventsCount = 0;
      }
    }
  }

  checkIfCompetitionHasOnlineEvents() {
    // tslint:disable:prefer-for-of
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let index = 0; index < this.sportsService.favoriteCompetitions.length; index++) {
      const favCmp = this.sportsService.favoriteCompetitions[index];
      // favCmp.isShown = false;
      const sport = this.sports.find(s => s.id === favCmp.sportId);
      if (sport) {
        const region = sport.regions.find(r => r.id === favCmp.regionId);
        const competition = region ? region.competitions.find(c => c.id === favCmp.id) : null;
        if (competition) {
          // competition.isInFavorites = true;
          // this.sportsService.favoriteCompetitions[index] = competition;
          if (competition.eventsCount > 0) {
            this.favoriteCompetitionsHaveOnlineEvents = true;
            return;
          }
        }
      }
      this.favoriteCompetitionsHaveOnlineEvents = false;
    }
  }

  addRemoveCompetitionToFavoritesFromService(eventSRC: IEventSrc) {
    // this.sports[eventSRC.sportId].regions[eventSRC.regionId].competitions[eventSRC.competitionId].isInFavorites = !this.sports[eventSRC.sportId].regions[eventSRC.regionId].competitions[eventSRC.competitionId].isInFavorites;
    const sport: ISport = this.sports.find(sp => sp.id === eventSRC.sportId);
    if (sport) {
      const region: IRegion = sport.regions.find(re => re.id === eventSRC.regionId);
      if (region) {
        const competition: ICompetition = region.competitions.find(cmp => cmp.id === eventSRC.competitionId);
        if (competition) {
          // this.favoriteCompetitionsHaveOnlineEvents = true;
          competition.isInFavorites = !competition.isInFavorites;
          // if (competition.isInFavorites && !this.sportsService.favoriteCompetitions.some(c => c.id === competition.id)) {
          //   this.sportsService.favoriteCompetitions.push(competition);

          // }else if (!competition.isInFavorites && this.sportsService.favoriteCompetitions.some(c => c.id === competition.id)) {
          //   const index = this.favoriteCompetitions.findIndex(fvc => fvc.id === competition.id);
          //   this.sportsService.favoriteCompetitions.splice(index, 1);
          //   // this.sportsService.favoriteCompetitions.splice(index, 1);
          // }
          const index = this.sportsService.favoriteCompetitions.findIndex(fvc => fvc.id === competition.id);
          this.sportsService.favoriteCompetitions[index] = competition;
          this.favoriteCompetitions = this.sportsService.favoriteCompetitions;
        }
      }
    }
    this.checkIfCompetitionHasOnlineEvents();
  }

  selectFromBanner() {
    const srcSelectionIds = this.sportsService.getSportRegionCompetitionSelectionIds(this.isLive);
    const sport = this.sports.find(s => s.id === srcSelectionIds.sId);
    if (sport) {
      let competition = null;
      let regionn = null;
      for (const region of sport.regions) {
        competition = region.competitions.find(c => c.id === srcSelectionIds.cId);
        if (competition) {
          regionn = region;
          break;
        }
      }
      if (competition) {
        this.selectCompetition(competition, regionn, sport);
      } else {
        this.selectSport(sport);
      }
    }
  }

  sendNoEventsNotification(message: string) {
    const error: ICustomNotification = {
      title: DynamicTranslations.notification_title,
      message,
      errorLevel: ErrorLevel.Notification,
    } as ICustomNotification;
    this.notificationService.forwardDataToNotification(error);
  }



  selectFromSelectionsChange() {

  }

  getSportName(sportId: number): string {
    return this.utilityService.getSportIcon(sportId);
  }

  public selectFirstSport(sports: ISport[]) {
    const sport = this.sports.find(s => !s.specialOfferType);
    if (sport) {
      this.selectSport(sport);
    } else {
      this.sportsService.notifyEmptyTreeLoaded();
    }
  }

  addRemoveCompetitionToFavorites(competition: ICompetition) {
    this.sportsService.addRemoveCompetitionToFavorites(competition);
  }

  toggleFavoriteCompetitions() {
    this.favoriteLeaguesIsExpanded = !this.favoriteLeaguesIsExpanded;
    this.deselectSports();
  }

  selectSport(sport: ISport): void {
    this.favoriteLeaguesIsExpanded = false;
    if (sport.isSelected) {
      sport.showRegions = !sport.showRegions;
      return;
    } else {
      this.showMostPopularSports = false;
      this.deselectSports();
      sport.isSelected = true;
      sport.showRegions = true;
    }
    // this.sportsService.selectSportNotify(sport, this.isLive, ComponentName.SportTreeComponent);
    if (!this.isMobileView) {
      if (this.sportsService.timeFilterValueGet === TimeFilter.All && sport.regions.length > 0 && sport.regions[0].competitions.length > 0) {
        this.selectCompetition(sport.regions[0].competitions[0], sport.regions[0], sport);
      } else {
        this.sportsService.selectSportNotify(sport, this.isLive, ComponentName.SportTreeComponent);
      }
    } else {
      this.sportsService.selectSportNotify(sport, this.isLive, ComponentName.SportTreeComponent);
    }

    this.queryParamService.pageType = PageType.Prematch;

    if (this.isMobileView) {
      this.selectedSport = sport;
    }

  }

  selectCompetition(competition: ICompetition, region: IRegion, sport: ISport, event = null, closeFavorites = false, isFromFavorites = false): void {
    if (closeFavorites) {
      this.favoriteLeaguesIsExpanded = false;
    }
    if (competition.isSelected) {
      competition.isExpanded = false;
      if (this.isMobileView) {
        competition.isSelected = false;
      }
      return;
    }

    this.deselectCompetitionsForSport(sport);

    competition.isSelected = true;
    competition.isExpanded = true;
    if (!isFromFavorites) {
      sport.isSelected = true;
      sport.showRegions = true;
    }

    this.sportsService.selectCompetitionNotify(competition, region, sport, this.isLive, ComponentName.SportTreeComponent);

    if (!this.isMobileView && document.getElementsByClassName('events-main-wrap')[0]) {
      this.eventHTML = document.getElementsByClassName('events-main-wrap')[0];
      // window.parent.scroll(0, this.eventHTML.offsetTop);
      window.parent.scroll(0, 0);
      console.log('scroll top');
      // $([window.parent.document.documentElement, window.parent.document.body]).animate({
      //   scrollTop: $('.events-main-wrap').offset().top
      // }, 100);

    }
    // else {
    //   // positioning scroll on opened legue
    //   const sportTree = document.getElementById('sport-tree');
    //   if (sportTree.scrollTop > event.screenY + 40) {
    //     console.log(event.screenY);
    //     sportTree.scrollTop = event.screenY;
    //   }
    // }
  }

  selectCompetitionFromFavorites(competition: ICompetition) {
    this.queryParamService.pageType = PageType.Prematch;
    const cmp = this.favoriteCompetitions.find(cmp => cmp.id === competition.id);
    if (cmp.isSelected) {
      cmp.isSelected = false;
      return;
    }
    this.deselectSports();

    const sport: ISport = this.sports.find(s => s.id === competition.sportId);
    if (!sport) {
      return;
    }
    const region: IRegion = sport.regions.find(r => r.id === competition.regionId);
    if (!region) {
      return;
    }
    const competitionToSelect: ICompetition = region.competitions.find(c => c.id === competition.id);
    if (!competitionToSelect) {
      return;
    }


    this.selectCompetition(competitionToSelect, region, sport, null, false, true);
  }

  deselectSports() {
    this.selectedSport = null;
    for (const sport of this.sports) {
      sport.isSelected = false;
      sport.showRegions = false;
      if (sport.regions) {
        this.deselectRegions(sport);
      }
    }
  }

  deselectRegions(sport: ISport) {
    for (const region of sport.regions) {
      region.isSelected = false;
      if (region.competitions) {
        this.deselectCompetitions(region);
      }
    }
  }

  deselectCompetitions(region: IRegion) {
    for (const competition of region.competitions) {
      competition.isSelected = false;
    }
  }

  deselectCompetitionsForSport(sport: ISport) {
    for (const region of sport.regions) {
      for (const competition of region.competitions) {
        competition.isSelected = false;
      }
    }
  }

  ngOnChanges(): void {
  }

  ngOnDestroy(): void {
    this.cacheChanges.unsubscribeForAllChangesPm();
    this.cacheChanges.removeAllEventsChangesSubscription(false);
    this.cacheChanges.removeSportsSubscribtion(false);
    this.subscription.unsubscribe();
  }
}
